import scssConstants from './variables.module.scss';

export const styleConstants = {
    labelWidth: parseInt(scssConstants.labelWidth),
    contentHorizontalPadding: parseInt(scssConstants.contentHorizontalPadding),
    spaceAround: parseInt(scssConstants.spaceAround),
    layoutBorderWidth: parseInt(scssConstants.layoutBorderWidth),
    itemBorder: parseInt(scssConstants.itemBorder),
    singleTypePadding: parseInt(scssConstants.singleTypePadding),
};
